(() => {
  if (customElements.get('bc-service-plan')) return;
  class ServicePlan extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.steps = [...this.children].filter(node => node.matches('article'));
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const reveal = step => {
        step.classList.add('is-step-active');
        this.classList.add('is-active');
        this.observer?.unobserve(step);
      };
      const revealAll = () => this.steps.forEach(reveal);
      if (!('IntersectionObserver' in window) || this.reduced.matches) {
        revealAll();
        return;
      }
      this.dataset.planReady = 'true';
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) reveal(entry.target); });
      }, {threshold: .1, rootMargin: '0px 0px -60px 0px'});
      this.steps.forEach(step => this.observer.observe(step));
      // Also cover a restored scroll position on the first rendered frame.
      this.frame = requestAnimationFrame(() => {
        this.steps.forEach(step => {
          const rect = step.getBoundingClientRect();
          if (rect.top < innerHeight - 60 && rect.bottom > 0) reveal(step);
        });
      });
      this.reduced.addEventListener('change', event => {
        if (event.matches) { revealAll(); this.observer?.disconnect(); }
      }, {signal: this.abort.signal});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('bc-service-plan', ServicePlan);
})();
